export default class ExternalExchange {
  constructor(
    public externalExchangeID: number,
    public name: string,
    public code: string,
    public isOpenrtb: boolean,
    public logoURL: string,
  ) {}

  static fromApi(apiObject) {
    return new ExternalExchange(
      apiObject.external_exchange_id,
      apiObject.name,
      apiObject.code,
      apiObject.is_openrtb,
      apiObject.logo_url,
    );
  }
}
